import {
  CircleNode,
  CircleNodeModel,
} from '@logicflow/core';

class CustomCircleModel extends CircleNodeModel {
  constructor(data, graphModel) {
    data.text = {
      value: data.text,
      x: data.x,
      // 自定义文本坐标：向下移动40px
      // y: data.y + 40,
    };
    super(data, graphModel);

    // 半径：控制圆形大小
    this.r = 30;
  }
}

export default {
  type: 'roadmap',
  view: CircleNode,
  model: CustomCircleModel,
};